import React, { useState, useRef } from "react";
import { Toaster, Position } from "@blueprintjs/core";
import {
  toast_uploadError,
  toast_uploadInProgress,
  toast_uploadSuccess,
} from "./Sequences/Toast";
import DialogAddChainedSession from "./ChainedSession/DialogAddChainedSession";
import TableChainedSession from "./ChainedSession/TableChainedSession";
import Session from "../../services/Session";

const CreatePanelChainedSession = ({
  chainedSession: chainedSessionProp,
  sessionId,
}) => {
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [chainedSession, setChainedSession] = useState(
    chainedSessionProp || ""
  );
  const [submiting, setSubmiting] = useState(false);
  const toaster = useRef();

  const handleOpenDialog = () => setDialogIsOpen(true);
  const handleCloseDialog = () => {
    setDialogIsOpen(false);
    setChainedSession("");
  };

  const handleChangeInput = (e) => {
    const value = e.target.value;
    setChainedSession(value);
    return value;
  };

  const handleChainedSession = () => {
    setSubmiting(true);

    const uploadToastKey = toaster.current.show(toast_uploadInProgress(0));
    Session.addChainedSession({
      sessionId,
      chainedSession,

      onComplete: () => {
        setDialogIsOpen(false);
        toaster.current.dismiss(uploadToastKey);
        toaster.current.show(toast_uploadSuccess());
      },
      onError: (error) => {
        setSubmiting(false);
        console.error("Error uploading link:", error);
        toaster.current.dismiss(uploadToastKey);
        toaster.current.show(toast_uploadError());
      },
    });
  };

  return (
    <div>
      <Toaster position={Position.TOP_RIGHT} autoFocus={false} ref={toaster} />
      <DialogAddChainedSession
        chainedSession={chainedSession}
        dialogIsOpen={dialogIsOpen}
        submiting={submiting}
        onCloseDialog={handleCloseDialog}
        onChangeInput={handleChangeInput}
        onAddChainedSession={handleChainedSession}
      />
      <TableChainedSession
        linkedSession={chainedSession}
        updateChainedSession={handleChainedSession}
        onDeleteChainedSession={handleChainedSession}
        onOpenDialog={handleOpenDialog}
      />
    </div>
  );
};

export default CreatePanelChainedSession;
